/**
 * Integrytas Group - Base App
 * React entry point for the MOBILE build (index.mobile.html → dist-mobile).
 *
 * Identical bootstrap to main.tsx (theme before first paint, i18n before the
 * tree mounts) but renders MobileApp — a mobile-first shell that reuses the
 * same auth/RBAC/services/page-registry layer as the desktop app.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import MobileApp from './mobile/MobileApp';
import './index.css';
import './mobile/mobile.css';
import { initI18n } from './i18n';
import { bootstrapThemeEarly } from './lib/theme/theme_store';

bootstrapThemeEarly();
initI18n();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('CSM mobile bootstrap failed: missing #root element in index.mobile.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <MobileApp />
  </React.StrictMode>,
);
